export default __webpack_public_path__ + "94bc1f8764fc3bae03398a76aa45f5c7.svg";